// resources/js/store/actions/filterActionTypes.js
export const SET_FILTER_TOOLS_STATE = 'SET_FILTER_TOOLS_STATE';
export const CLEAR_FILTER_TOOLS_STATE = 'CLEAR_FILTER_TOOLS_STATE';
